// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2lKxQ","label":"Section_label__3_e5E","contentWrap":"Section_contentWrap__3-gaH","footer":"Section_footer__3X43h","footerInner":"Section_footerInner__2NyKD"};